import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-37de602e")

_pushScopeId("data-v-37de602e")
const _hoisted_1 = { class: "shop-wrapper has-background-image customer-login-page" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "bottom-area" }, [
  /*#__PURE__*/_createVNode("div", { class: "dots-loader" }, [
    /*#__PURE__*/_createVNode("span"),
    /*#__PURE__*/_createVNode("span"),
    /*#__PURE__*/_createVNode("span"),
    /*#__PURE__*/_createVNode("span"),
    /*#__PURE__*/_createVNode("span")
  ])
], -1)
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = {
  key: 0,
  class: "row"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "col-md-12 text-center mt-3" }, [
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-solid fa-ban",
    style: {"font-size":"50px","color":"red"}
  })
], -1)
const _hoisted_6 = { class: "col-md-12 mt-4 pb-4" }
const _hoisted_7 = /*#__PURE__*/_createVNode("p", null, "Oops, You don't have access to this portal. Sign in with an account that can access this portal, or request access from the portal owner", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" For assistance ")
const _hoisted_9 = { href: "mailto:hello@${ASSETS_CLIENT_NAME}.com" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("img", {
        loading: "lazy",
        src: _ctx.dynamicAsset,
        alt: "YellowBeard"
      }, null, 8, ["src"])
    ]),
    (_ctx.permission_error)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _hoisted_5,
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _hoisted_8,
            _createVNode("a", _hoisted_9, "hello@" + _toDisplayString(_ctx.ASSETS_CLIENT_NAME) + ".com", 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})